import { Client, type AuthenticationProvider } from '@microsoft/microsoft-graph-client';

/**
 * Runtime-neutral Graph client factory.
 *
 * The SPA injects an MSAL-backed `AuthenticationProvider`; the `@repancy/azure`
 * worker injects a Managed-Identity-backed one (via `@azure/identity`). Neither
 * runtime detail leaks into this package.
 *
 * Callers are responsible for caching the returned client if they want
 * singleton semantics — graph-core does not memoize. The SPA's wrapper at
 * `packages/repancy/src/lib/graph/graphClient.ts` keeps the cache + the
 * `__setGraphClientForTests` hook so existing test plumbing is unchanged.
 */
export function makeGraphClient(authProvider: AuthenticationProvider): Client {
  return Client.initWithMiddleware({ authProvider });
}

export type { AuthenticationProvider } from '@microsoft/microsoft-graph-client';
